import { createFileRoute } from '@tanstack/react-router';
import BaseView from 'containers/Base/BaseView';
import { baseModuleConfigs } from 'containers/Base/baseModuleConfigs';
import { useNotificationMutations } from 'containers/Notifications/useNotificationMutations';
import { prefetchGridSchema } from '../-utils/loaders';

function NotificationsRoute() {
  const { customAdd, customChange, customDelete, customList } =
    useNotificationMutations();
  return (
    <BaseView
      configuration={baseModuleConfigs.Notifications}
      customAdd={customAdd}
      customChange={customChange}
      customDelete={customDelete}
      customList={customList}
    />
  );
}

export const Route = createFileRoute('/_authenticated/notifications')({
  loader: ({ context }) =>
    prefetchGridSchema(
      context.queryClient,
      baseModuleConfigs.Notifications.itemType
    ),
  component: NotificationsRoute,
});
